<template>
  <div v-if="!this.loading" class="animated fadeIn">
      <b-row>
        <b-col v-show="showbtn" lg="12">
          <b-col cols="3" class="pull-right m-3">
            <btnPlus/>
          </b-col>
        </b-col><!--/.col-->
        <b-col lg="12">
          <tableDinamic :items="this.recarga.items" :fields="this.dataLoad.fields" :methodsTable="this.dataLoad.methodsTable" :excelFooter="excelFooter" :btndel='btndel' :btneye='btneye' :exportExcel='exportExcel' :excelHead='excelHead' :nameFileExcel='nameFileExcel'></tableDinamic>
        </b-col><!--/.col-->
      </b-row><!--/.row-->
  </div>
</template>
<script>
import btnPlus from '@/views/base/buttons/btnPlus.vue'
import tableDinamic from '@/views/base/table/Table.vue'
// import { mapGetters } from 'vuex'
export default {
  name: 'List',
  components: {
    btnPlus,
    tableDinamic
  },
  props: {
    mapState: { required: true },
    allDispatch: { required: true },
    showbtn: {type:Boolean, default: true},
    btndel: {type:Boolean, default: true},
    btneye: {type:Boolean, default: true},
    exportExcel: {type:Boolean, default: false},
    excelHead: {type:Object},
    excelFooter: { required: false},
    nameFileExcel: { required: false},
  },
  data () {
    return {
      loading: true,
      form: {},
      dataLoad: {}
    }
  },
  watch:{
    dataLoad(newvalue){
      console.log('entro')
    }
  },
  computed: {
    recarga:{
      get(){
        return this.dataLoad
      },
      set(newvalue){
        this.dataLoad = newvalue
      }
    }
  },
  mounted () {
    this.$store.dispatch(this.allDispatch).then((response) => {
      this.dataLoad = this.$store.getters[this.mapState]
      this.recarga = this.$store.getters[this.mapState]
      this.loading = false
    }).catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
  },
  methods: {
    
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modules/base/list.vue